import { ConcreteEncodable } from "./ConcreteEncodable";

import { VisbilityProfileChangeEventImplEncoder } from "../../encoder/VisbilityProfileChangeEventImplEncoder";

import * as CubiqTS from "../../index";
import { VisbilityProfileChangeEvent } from "../VisbilityProfileChangeEvent";

export class VisbilityProfileChangeEventImpl
  extends ConcreteEncodable
  implements VisbilityProfileChangeEvent
{
  public static enType: string = "com.bcdfx.model.VisbilityProfileChangeEventImpl";

  /*FID=1*/
  public visibleClientCds: Array<string> | null = null;
  /*FID=2*/
  public user: string;
  /*FID=3*/
  public isTraderPrevisibility: boolean;
  /*FID=4*/
  public userVisibilityProfile: CubiqTS.UserVisibilityProfile | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = VisbilityProfileChangeEventImplEncoder.Instance;
    this.setEncodableType(VisbilityProfileChangeEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "VisbilityProfileChangeEventImpl[" +
      "visibleClientCds=" +
      this.visibleClientCds +
      "user=" +
      this.user +
      "isTraderPrevisibility=" +
      this.isTraderPrevisibility +
      "userVisibilityProfile=" +
      this.userVisibilityProfile +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
